module.exports = __webpack_public_path__ + "static/media/logo-sanh@2x.921ec07b.png";